import moment from "moment";
import React, { useState } from "react";

import styled from "styled-components";
import DisplayAttachmentsModal from "../../../components/DisplayAttachments.modal";

import { Reject } from "./Reject.component";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 20px;
  width: 100%;
`;

const Button = styled.div`
  font-size: 20px;
  background: ${({ isValid }) => (isValid ? "green" : "red")};
  padding: 10px;
  border: 1px solid black;
  border-radius: 5px;
  width: 40%;
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: white;
`;
const Span = styled.div`
  font-size: 20px;
  margin: 10px;
`;

const BigSpan = styled.div`
  font-size: 30px;
  margin: 10px;
`;
const roundToTwoDigits = value => Math.round(value * 100) / 100;
export const Expense = ({ expense, validate, rejectTypes, reject }) => {
  if (!expense) return <BigSpan>Aucune note de frais pour ce mois</BigSpan>;
  const [isRejectFormVisible, setIsRejectFormVisible] = useState(false);
  return (
    <Container>
      <BigSpan>{expense.user_fullname}</BigSpan>
      {Array.isArray(expense.clients) && <Span>Dossier(s) : {expense.clients.map(c => c.label).join(",")}</Span>}
      <Span>Entreprise : {expense.user_company_label}</Span>
      <Span>
        Date de la note de frais : {moment(expense.date).format("DD/MM/YYYY")} (créée le :{" "}
        {moment(expense.created_at).format("DD/MM/YYYY")})
      </Span>
      <Span>
        Note de frais acceptée par : {expense.processed_by.user_fullname || "automatique"} le{" "}
        {moment(expense.processed_at).format("DD/MM/YYYY")}
      </Span>

      <Span>Type : {expense.type.def}</Span>
      <Span>Numero compte : {expense.type.account_num}</Span>
      {expense.calculatedPrice && <Span>Prix TTC calculé : {roundToTwoDigits(expense.calculatedPrice)}€</Span>}
      <Span>Prix TTC indiqué sur le ticket : {expense.price}€</Span>
      {Array.isArray(expense.tva) && expense.tva.filter(t => t.percentage !== 0).length > 0 ? (
        <div className="flex">
          <Span> Montant(s) TVA : </Span>

          <Span>
            {expense.tva
              .map(t =>
                t.percentage === 0 ? `sans TVA : ${roundToTwoDigits(t.amount)}€` : `${t.percentage}%: ${t.amount_tva}€`
              )
              .join(" - ")}
          </Span>
        </div>
      ) : (
        <Span>Pas de TVA</Span>
      )}
      {isRejectFormVisible && <Reject rejectTypes={rejectTypes} expense={expense} reject={reject}></Reject>}
      <div style={{ display: "flex", justifyContent: "space-around", width: "100%", margin: 20 }}>
        <Button onClick={() => setIsRejectFormVisible(v => !v)}>
          {isRejectFormVisible ? "Annuler le rejet" : "Rejeter"}
        </Button>
        {!isRejectFormVisible && (
          <Button isValid onClick={() => validate(expense._id)}>
            Valider
          </Button>
        )}
      </div>
      <Span>{`Nombre de pièces jointes : ${expense.attachements.map(file => file).length}`} </Span>
      <div style={{ overflow: "scroll" }}>
        <DisplayAttachmentsModal attachments={expense.attachements.map(file => file)} />
      </div>
    </Container>
  );
};



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/Accounting/components/Expense.component.js